import { Router } from "@angular/router";

export class UrlHelper {
    /**
     * The URL requested, before initial routing.
     */
    static readonly initialUrl = location.href;

    static readonly entryUrl = "calendar";

    static readonly v2EntryUrl = "patients";

    static readonly loginUrl = "account/login";

    static getQueryParameters(): Record<string, string> {
        const params = new URLSearchParams(window.location.search);
        const result: Record<string, string> = {};

        params.forEach((value, key) => {
            result[key] = value;
        });

        return result;
    }

    static navigateToMedicalCareCall(router: Router, appointmentId: string): any {
        let queryParams = {
            returnUrl: location.pathname,
        };
        router.navigate(["/medical-care/call/" + appointmentId], { queryParams: queryParams }).then();
    }
}
